import React from 'react';
import ReactDOM from 'react-dom';
import './scss/app.scss';
import App from './js/App';
import reportWebVitals from './reportWebVitals';
import StoreProvider from './js/StoreProvider';
import PostMessageHandler from './js/PostMessageHandler';

ReactDOM.render(
    <React.StrictMode>
        <StoreProvider>
            <PostMessageHandler>
                <App />
            </PostMessageHandler>
        </StoreProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
